<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-button @click="onSearch" variant="info" class="p-2">
      <span v-if="!this.bButtonIcon">Buscar</span>
      <i v-if="this.bButtonIcon" class="zmdi zmdi-search"></i>
    </b-button>
  </div>
  <b-modal :id="infoModal.id" size="xl" :title="infoModal.title" dialog-class="modal-search">
       <div class="modal-body">
          <form @submit.stop.prevent="searching">
                 <b-row>
                  <b-col>
                  <b-form-group id="input-group-2"
                      label="Ingrese descripción a buscar:" label-for="input-2">
                      <div class="col-md-12 d-inline-flex align-items-center mb-5">
                        <b-form-input
                        id="input-2"
                        class="mr-2"
                        :state="($v.resoursetosearch.$dirty && submitted)? !$v.resoursetosearch.$error : null"
                        v-model.trim="resoursetosearch"
                        >
                        </b-form-input>
                        <b-button type="submit" size="md" variant="info">Buscar</b-button>
                      </div>
                  </b-form-group>
                  </b-col>
                </b-row>
                <div class="row my-div-scroll">
                  <div class="col-lg-6" v-for="imagen in resources" v-bind:key="imagen.ID">
                      <div class="row image-card">
                          <div class="file-name col-lg-12">
                            <b-button class="d-inline ml-auto" size="sm" variant="info" @click="$emit('selected', imagen)">
                              Seleccionar
                            </b-button>
                            <p class="m-b-5 text-muted d-inline"> {{imagen.NOMBRE}} </p>
                          </div>
                          <div class="col-lg-12 cardtheme">
                            <div class="file p-2 d-flex flex-row justify-content-center align-items-center" style="min-height:200px">
                              <div class="hover">
                                  <a :href="getTranslation(imagen.FICHERO)" target="_blank" title="Abrir a pantalla completa">
                                    <span>{{languageGlobal + ' '}}</span><i class="zmdi zmdi-loupe"></i>
                                  </a>
                              </div>
                              <div class="image">
                                <img onerror="this.onerror=null;this.src='./notfound.png';" :src="getTranslation(imagen.FICHERO)"
                                  alt="img" class="img-fluid" width="auto" style="max-height:200px">
                              </div>
                            </div>
                          </div>
                      </div>
                </div>
            </div>
          </form>
      </div>

      <template v-slot:modal-footer>
        <div class="col-md-12 d-flex justify-content-end mb-3">
          <b-button @click="onCreate" variant="success" class="p-2">
            <span> <i class="zmdi zmdi-plus"></i> Crear recurso</span>
          </b-button>
        </div>
      </template>

    </b-modal>
</div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';
import translationMixin from '../../../mixins/translation';

export default {
  props: ['idModal', 'bButtonIcon'],
  mixins: [translationMixin],
  data() {
    return {
      submitted: false,
      searchtext: null,
      resoursetosearch: null,
      resources: [],
      itemSelected: {
        ID: null,
        NOMBRE: null,
        FICHERO: [],
      },
      texts: [],
      infoModal: {
        id: this.idModal,
        title: 'Buscador de imagenes',
      },
    };
  },
  validations: {
    resoursetosearch: {
      required,
      minLength: minLength(2),
    },
  },
  methods: {
    onSearch() {
      this.resources = [];
      this.resoursetosearch = null;
      this.itemSelected.ID = null;
      this.itemSelected.NOMBRE = null;
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    async searching() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      this.resources = [];
      this.loading = true;
      const response = await this.axios.get('image/searching', {
        params: {
          resoursetosearch: this.resoursetosearch,
        },
      });
      this.resources = response.data;
      this.loading = false;
    },
    onCreate() {
      const routeData = this.$router.resolve({ name: 'images' });
      window.open(routeData.href, '_blank');

      setTimeout(() => {
        const bc = new BroadcastChannel('new_resource_image_open');
        bc.postMessage({});
      }, 500);
    },
  },
  mounted() {
    const self = this;
    const bc = new BroadcastChannel('new_resource_image');
    bc.onmessage = (ev) => {
      self.resources.push(ev.data);
    };
  },
};
</script>
